"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialSwitch = exports.MaterialSwitchUnstyled = void 0;
const material_ui_1 = require("material-ui");
const Form_1 = require("material-ui/Form");
const Switch_1 = require("material-ui/Switch");
const react_1 = require("react");
const React = require("react");
const decorate = material_ui_1.withStyles(theme => ({
    bar: {
        backgroundColor: "#d6d6d6",
        borderRadius: 12.5,
        height: 20
    },
    icon: {
        height: 18,
        width: 18,
        marginTop: 6,
        boxShadow: "none",
        backgroundColor: "#ffffff"
    },
    root: {
        marginTop: "-5px"
    }
}));
class MaterialSwitchUnstyled extends react_1.Component {
    render() {
        const { classes, checked, disabled, label, value, isDisabled // E-044
         } = this.props;
        return (React.createElement(Form_1.FormGroup, null,
            React.createElement(Form_1.FormControlLabel, { control: React.createElement(Switch_1.default, { classes: classes, checked: checked, onChange: this.props.onChange, disabled: isDisabled && isDisabled }), label: label, "data-tip": "Manage master formulary groups", "data-for": "manage-master", disabled: disabled, value: value })));
    }
}
exports.MaterialSwitchUnstyled = MaterialSwitchUnstyled;
exports.MaterialSwitch = material_ui_1.withTheme()(decorate(MaterialSwitchUnstyled));



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/switch/switch.tsx
// module id = 2789
// module chunks = 0